var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Find-a-business---Agencies-only",
    transform: "translate(-473.000000, -106.000000)",
    fill: "#021228",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(473.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(5.000000, 5.000000) rotate(45.000000) translate(-5.000000, -5.000000) ",
    points: "-1.42824347 4.35717565 11.4282435 4.35717565 11.4282435 5.64282435 -1.42824347 5.64282435"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2",
    transform: "translate(5.000000, 5.000000) rotate(-45.000000) translate(-5.000000, -5.000000) ",
    points: "-1.42824347 4.35717565 11.4282435 4.35717565 11.4282435 5.64282435 -1.42824347 5.64282435"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.338f07c720a5b7fe8bc7fc26ca2fa1ed.svg";
export { ForwardRef as ReactComponent };